import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, ResponsiveContext } from 'grommet';
import { reportDefinitions } from './report-definitions';
import { Box, Card, CardBody, CardHeader, Link, ListPage, Text } from '/src/components';
import { getIsMobile } from '/src/utils';

export const ReportsLibraryPage: React.FC = () => {
  const { t } = useTranslation();
  const screenSize = useContext(ResponsiveContext);
  const isMobile = getIsMobile(screenSize);

  return (
    <ListPage
      title={t('navigation:reportsLibrary')}
      pageHeader={
        <Box align="center" margin={{ bottom: '2rem' }}>
          <Text size="xxlarge">{t('navigation:reportsLibrary')}</Text>
        </Box>
      }
    >
      <Grid
        columns={isMobile ? ['1fr'] : ['minmax(0, 27rem)', 'minmax(0, 27rem)']}
        gap="medium"
        fill="horizontal"
        justifyContent="center"
      >
        {reportDefinitions.map((definition) => {
          const Icon = definition.icon;

          return (
            <Link key={definition.key} to={`/reports/${definition.slug}`} textDecoration="none">
              <Card height="12rem">
                <CardHeader title={t(definition.titleKey as never)} icon={<Icon size="24px" />} />
                <CardBody pad="1.5rem" flex="grow" innerBoxProps={{ flex: 'grow' }}>
                  <Text size="medium" color="dark-2">
                    {t(definition.descriptionKey as never)}
                  </Text>
                </CardBody>
              </Card>
            </Link>
          );
        })}
      </Grid>
    </ListPage>
  );
};
